import { Box, Dialog, Button } from '@mui/material';
import { useHistory } from 'react-router-dom'
import Onboarding1 from '../../../../assets/images/home/Onboarding1.png'
import { useState } from 'react';
export const Success = ({dialog, setDialog, input}) => {
    const history = useHistory()
    const [step, setStep] = useState(1)
    const content = ['We have prepared thousands of questions for you to practice answering. ', 'Use My Reviewer feature to upload your questions and use it as your own online reviewer.']
    const label = ['Explore Take Exam feature', 'Explore My Reviewer feature']
    const handleNext = (action) => {
        if(action === 'next'){
            setStep(2)
        }else{
            setDialog({open: false, name: null})
            history.push('/psl?account=wtd') 
        }
    }
    return (
        <Dialog open={dialog} PaperProps={{sx:{borderRadius: '16px', width:'593px', p: '24px 25px', background: 'linear-gradient(327.71deg, #FFFFFF 63.28%, #EAF4E8 80.37%, #EEEDF5 100.97%)'}}}>
            <Box fontSize="24px" fontWeight={700} color="#313131" mb="10px">Success!</Box>
            <Box fontSize="16px" fontWeight={600} mb="10px">You have set {input.name} as your active exam.</Box>
            {
                input.name === 'Certified Public Accountant' ? (
                    <Box fontSize="14px" color="#313131" mb="10px">{content[step-1]}</Box>
                ) : (
                    <Box fontSize="14px" color="#313131" mb="10px">{content[1]}</Box>
                )
            }
            <Box sx={{backgroundImage: `url(${Onboarding1})`, height: '325px', width: '545px'}}>
                {
                    input.name === 'Certified Public Accountant' ? (
                        <Box color="#FFFFFF" fontSize="20px" fontWeight={600} mt="45px" textAlign="center">{label[step-1]}!</Box>
                    ) : (
                        <Box color="#FFFFFF" fontSize="20px" fontWeight={600} mt="45px" textAlign="center">{label[1]}!</Box>
                    )
                }
            </Box>
            {
                input.name === 'Certified Public Accountant' ? (
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Box fontSize="16px" fontWeight={600} color="#A2A3A9">{step} of 2</Box>
                        <Box display="flex" alignContent="center">
                        {
                            step === 1 ? (
                                <Button variant="contained" sx={{padding: '6px 24px', mt: '24px', mb: '24px', background: '#256EFF', color: '#fff'}} onClick={()=>handleNext('next')}>Next</Button>
                            ) : (
                                <Button variant="contained" sx={{padding: '6px 24px', mt: '24px', mb: '24px', background: '#256EFF', color: '#fff'}} onClick={()=>handleNext('awesome')}>Awesome!</Button>
                            )
                        }
                        </Box>
                    </Box>
                ) : (
                    <Box display="flex" justifyContent="flex-end">
                        <Button variant="contained" sx={{padding: '6px 24px', mt: '24px', mb: '24px', background: '#256EFF', color: '#fff'}} onClick={()=>handleNext('awesome')}>Awesome!</Button>
                    </Box>
                )
            }
            
        </Dialog>
    )
}